import { VisitNodePassage } from "hooks/widget-data/datapoints-api/types";
const createTooltip = (xColumns, x, yColumns, y, value) => {
    const label = `${xColumns?.[x]?.label}, ${yColumns?.[y]?.label}`;
    return [[label, value.toString()]];
};
const getMeasures = (element) => {
    let returnValues = [];
    if (!element?.data) {
        returnValues = [element.measures];
    }
    element?.data?.forEach((singleElement) => returnValues.push(...getMeasures(singleElement)));
    return returnValues;
};
const init = (context, axisValues) => {
    const allMeasures = context.staticData.root.flatMap((x) => getMeasures(x));
    const separatedXColumns = allMeasures.map((x) => ({
        label: x?.[axisValues.x.name] ?? axisValues.x.name ?? axisValues.x.label ?? "",
        measureName: axisValues.x.name,
        value: x?.[axisValues.x.name]
    }));
    const separatedYColumns = allMeasures.map((x) => ({
        label: x?.[axisValues.y.name] ?? axisValues.y.name ?? axisValues.y.label ?? "",
        measureName: axisValues.y.name,
        value: x?.[axisValues.y.name]
    }));
    context.staticData.customResult = [
        {
            matrixValues: [],
            xColumns: Array.from(new Set(separatedXColumns.map((x) => x.value)))
                .map((value) => separatedXColumns.find((x) => x.value === value)),
            yColumns: Array.from(new Set(separatedYColumns.map((x) => x.value)))
                .map((value) => separatedYColumns.find((x) => x.value === value))
        }
    ];
};
const addPoint = (context, axisValues, args) => {
    if (context.staticData.customResult) {
        const customResult = context.staticData.customResult?.[0];
        const newData = args?.visitable?.data?.flatMap((x) => getMeasures(x));
        newData?.forEach((singleElement) => {
            const xIndex = customResult.xColumns.findIndex((x) => x.value === singleElement?.[axisValues.x.name]);
            const yIndex = customResult.yColumns.findIndex((x) => x.value === singleElement?.[axisValues.y.name]);
            if (customResult.matrixValues.findIndex((x) => x.x === xIndex && x.y === yIndex) === -1) {
                customResult.matrixValues.push({
                    custom: {
                        formattedValue: singleElement?.[axisValues.value.formattedValueName ?? axisValues.value.name] ?? "",
                        tooltip: createTooltip(customResult.xColumns, xIndex, customResult.yColumns, yIndex, singleElement?.[axisValues.value.formattedValueName ?? axisValues.value.name] ?? 0)
                    },
                    value: singleElement?.[axisValues.value.name] ?? "",
                    x: xIndex,
                    y: yIndex
                });
            }
        });
        if (args?.context.visitNodePassage === VisitNodePassage.NodeLast) {
            args.visitable.additionalData = {
                max: Math.max(...customResult.matrixValues.map((x) => x.value)),
                min: Math.min(...customResult.matrixValues.map((x) => x.value))
            };
        }
    }
};
export const dynamicHeatMap = (params) => (args) => {
    if (!args.context.staticData.customResult?.length && args.context.visitNodePassage === VisitNodePassage.NodeFirst) {
        init(args.context, params.dynamicAxisValues);
    }
    else if (args.context.visitNodePassage === VisitNodePassage.Leaf || args.context.visitNodePassage === VisitNodePassage.NodeLast) {
        addPoint(args.context, params.dynamicAxisValues, args);
    }
};
